/**
 * USB/HID product identifiers paired with SCUF_VENDOR_ID from vendorIds.ts.
 * Grouped by vendor ID, including accessories that share it.
 * @module
 * @internal
 */

/**
 * Product identifier (PID) of the SCUF Vantage controller.
 * Pair with SCUF_VENDOR_ID in the supported-controller filter.
 */
export const SCUF_VANTAGE_PRODUCT_ID = 0x7725
